import FilterTextField from '../baseInputTypes/FilterTextField'

export const ProductId = () => (
  <FilterTextField label="Product ID" fieldPath={'mediaDetails.productId'} />
)
